import Test from './Test';
export default Test;